module.exports = __webpack_public_path__ + "static/media/skills.ee50c314.jpg";